import React, { useState } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import POAddressViewMode from 'components/admin/warehouse/WarehouseDetail/POAddressViewMode';
import POAddressEditForm from 'components/admin/warehouse/WarehouseDetail/POAddressEditForm';

import { adminWarehouseApi } from 'api';

const POAddressSection = ({ warehouseId, purchaseOrderAddress, refetch }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const updatePOAddress = async (warehouseId, data) => {
    setLoading(true);
    setError(null);

    try {
      await adminWarehouseApi.updatePurchaseOrderAddress(warehouseId, data);
    } catch (err) {
      setError(err.message || 'Failed to update purchase order address');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e, formValues) => {
    e.preventDefault();

    try {
      await updatePOAddress(warehouseId, formValues);
      await refetch();

      setIsEditing(false);
      toast.success('Purchase order address updated successfully');
    } catch (err) {
      toast.error('Failed to update purchase order address');
    }
  };

  return (
    <Card className="mt-4">
      <Card.Header className="bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <h5 className="mb-0">Purchase Order Address</h5>

            <small className="text-muted ms-2">
              Address for Purchase Order
            </small>
          </div>

          {!isEditing && (
            <Button variant="primary" size="sm" onClick={handleEditClick}>
              <FontAwesomeIcon icon="edit" className="me-2" />
              Edit
            </Button>
          )}
        </div>
      </Card.Header>

      <Card.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        {isEditing ? (
          <POAddressEditForm
            purchaseOrderAddress={purchaseOrderAddress}
            onSubmit={handleSubmit}
            onCancel={() => setIsEditing(false)}
            isLoading={loading}
          />
        ) : (
          <POAddressViewMode purchaseOrderAddress={purchaseOrderAddress} />
        )}
      </Card.Body>
    </Card>
  );
};

export default POAddressSection;
